import { createSlice } from '@reduxjs/toolkit';

// Initial state for the user
const initialState = {
  currentUser: null,
  userRole: null,
  userEmail: null, // Independent state for the email
};

// Create the slice
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.currentUser = action.payload.user;
      state.userRole = action.payload.role;
    },
    setUserEmail: (state, action) => {
      state.userEmail = action.payload; // Set email independently
    },
    removeUser: (state) => {
      state.currentUser = null;
      state.userRole = null;
      state.userEmail = null;
    },
  },
});

// Export actions
export const { setUser, setUserEmail, removeUser } = userSlice.actions;

// Export the reducer to be used in the store
export default userSlice.reducer;
